<template>
  <div class="border border-dark rounded packing-list-container">

    <div
      class="row"
      v-for="(category, index) in itemsCategoryListFiltered"
      :key="`category-${index}`"
    >
      <div class="col">
        <div
          class="d-flex align-items-center py-2 px-3 cursor-pointer"
          data-bs-toggle="collapse"
          :data-bs-target="`#collapseCategory${category.id}`"
          aria-expanded="false"
          :aria-controls="`collapseCategory${category.id}`"
          :class="{
            'border-top border-dark': index !== 0
          }"
        >
          <img :src="category.icon.url" width="20" class="me-2">
          <span>{{ category.name }}</span>

          <span class="material-icons ms-auto">keyboard_arrow_down</span>
        </div>
        <div class="collapse border-top" :id="`collapseCategory${category.id}`">
          <div class="py-1">

            <div
              class="row"
              v-for="(item, index) in category.items"
              :key="`item-${index}`"
            >
              <div class="col">
                <div class="d-flex align-items-center py-1 ps-3 pe-2 fs-8">
                  <span class="text-truncate" :title="item.name">
                    {{ item.name }}
                  </span>
                  <span
                    class="material-icons mx-1 me-md-3 fs-7 primary-text-color"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    :data-bs-title="item.comment"
                  >info</span>

                  <div class="ms-auto d-flex item-count-options align-items-center justify-content-between">
                    <span
                      class="material-icons p-1 fs-7 primary-text-color cursor-pointer"
                      @click="removeItem(item.id)"
                    >
                      remove
                    </span>
                    <input
                      type="text"
                      class="input-count"
                      :value="itemRecordCount(item.id)"
                      @input="updateItemInput(item.id, $event.target.value)"
                      @blur="$event.target.value = itemRecordCount(item.id)"
                    >
                    <span
                      class="material-icons p-1 fs-7 primary-text-color cursor-pointer"
                      @click="addItem(item.id)"
                    >
                      add
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import segmentTrack from '../../../common/mixins/segmentTrack'

export default {
  mixins: [segmentTrack],

  props: ['itemsCategoryList', 'value'],

  data() {
    return {
      warehouseListItems: this.value || []
    };
  },

  mounted() {
    this.sendSegmentTrack('MEXICAN_WAREHOUSE_BOT_SEGMENT_PUBLIC', 'Mexican Warehouse Rental Bot', 'Packing List Step')
  },

  computed: {
    itemRecordById() {
      return (itemId) => {
        return this.warehouseListItems.find(item => item.movingItemId === itemId);
      };
    },

    itemsCategoryListFiltered() {
      return this.itemsCategoryList.filter(category => category.items.length > 0);
    },

    itemRecordCount() {
      return (itemId) => {
        const item = this.itemRecordById(itemId);
        return item ? item.count : 0;
      };
    }
  },

  methods: {
    addItem(itemId) {
      const item = this.itemRecordById(itemId);

      if (item) {
        item.count += 1;
      } else {
        this.warehouseListItems.push({
          movingItemId: itemId,
          count: 1
        });
      }

      this.$emit('input', this.warehouseListItems);
    },

    removeItem(itemId) {
      const item = this.itemRecordById(itemId);

      if (!item || item.count === 0) return;

      item.count -= 1;

      this.$emit('input', this.warehouseListItems);
    },

    updateItemInput(itemId, value) {
      let item = this.itemRecordById(itemId);
      value = parseInt(value) || 0;

      if (value < 0) value = 0;
      if (!item) this.addItem(itemId);

      item = this.itemRecordById(itemId);
      item.count = value;

      this.$emit('input', this.warehouseListItems);
    }
  }
}
</script>


<style scoped>
.input-count {
  outline: none;
  width: 30px;
  border: none;
  text-align: center;
  padding: 0;
  border-bottom: 1px solid transparent;
  transition: all .2s ease-in;
}

.input-count:hover {
  border-bottom: 1px solid #6c757d;
}
</style>
